const normalize = (value) => String(value ?? "").trim().toLocaleLowerCase("ru-RU");

export const VACANCY_PLACEMENTS = {
    ALL: "all",
    HH: "hh",
    LOCAL: "local",
    TEMPLATE: "template",
};

export const VACANCY_DEADLINES = {
    ALL: "all",
    OVERDUE: "overdue",
    WARNING: "warning",
    ON_TRACK: "on-track",
};

export function filterVacancies(
    vacancies,
    { query = "", department = "all", placement = "all", deadline = "all" } = {}
) {
    const normalizedQuery = normalize(query);

    return (Array.isArray(vacancies) ? vacancies : []).filter((vacancy) => {
        if (normalizedQuery) {
            const searchable = [vacancy?.name, vacancy?.public_code, vacancy?.city]
                .map(normalize)
                .join(" ");
            if (!searchable.includes(normalizedQuery)) return false;
        }

        if (department !== "all" && normalize(vacancy?.department) !== normalize(department)) {
            return false;
        }

        const isPublishedToHH = Boolean(vacancy?.hh_vacancy_id || vacancy?.hh_vacancy_url);
        if (placement === VACANCY_PLACEMENTS.HH && !isPublishedToHH) return false;
        if (placement === VACANCY_PLACEMENTS.LOCAL && (isPublishedToHH || vacancy?.is_template)) return false;
        if (placement === VACANCY_PLACEMENTS.TEMPLATE && !vacancy?.is_template) return false;

        if (deadline === VACANCY_DEADLINES.OVERDUE && vacancy?.deadline_state !== "overdue") return false;
        if (deadline === VACANCY_DEADLINES.WARNING && vacancy?.deadline_state !== "warning") return false;
        if (
            deadline === VACANCY_DEADLINES.ON_TRACK
            && ["overdue", "warning"].includes(vacancy?.deadline_state)
        ) {
            return false;
        }

        return true;
    });
}

export function getVacancyDepartments(vacancies) {
    return [...new Set(
        (Array.isArray(vacancies) ? vacancies : [])
            .map((vacancy) => String(vacancy?.department || "").trim())
            .filter(Boolean)
    )].sort((left, right) => left.localeCompare(right, "ru"));
}
